import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="w-full bg-primary-950 text-background-200">
      <div className="w-full px-4 md:px-8 py-10 md:py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-10">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2.5 mb-4">
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-accent-500 text-primary-950">
                <i className="ri-movie-2-fill text-lg"></i>
              </span>
              <span className="text-lg font-bold text-background-50">
                国语对白做受<span className="text-accent-400">69</span>
              </span>
            </div>
            <p className="text-sm leading-relaxed text-background-400 max-w-lg">
              国语对白做受69 是一个面向影视爱好者的资源展示与资讯平台，汇集电影、电视剧等多类型内容，
              提供分类浏览、详情查看与最新资讯，帮助你更高效地发现值得一看的影视作品。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">
              <Link to="/category/all" className="hover:text-accent-400 transition-colors cursor-pointer">
                影视分类
              </Link>
            </h4>
            <ul className="space-y-2.5 text-sm">
              <li>
                <Link to="/category/movie" className="text-background-400 hover:text-accent-400 transition-colors cursor-pointer">
                  电影
                </Link>
              </li>
              <li>
                <Link to="/category/tv" className="text-background-400 hover:text-accent-400 transition-colors cursor-pointer">
                  电视剧
                </Link>
              </li>
              <li>
                <Link to="/category/all" className="text-background-400 hover:text-accent-400 transition-colors cursor-pointer">
                  全部资源
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">
              <Link to="/news" className="hover:text-accent-400 transition-colors cursor-pointer">
                内容与关于
              </Link>
            </h4>
            <ul className="space-y-2.5 text-sm">
              <li>
                <Link to="/news" className="text-background-400 hover:text-accent-400 transition-colors cursor-pointer">
                  影视资讯
                </Link>
              </li>
              <li>
                <Link to="/special" className="text-background-400 hover:text-accent-400 transition-colors cursor-pointer">
                  主题专题
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-background-400 hover:text-accent-400 transition-colors cursor-pointer">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-primary-800 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-background-500">
          <p>© 2026 国语对白做受69 · 影视资源与影视资讯平台</p>
          <p className="text-center sm:text-right">
            本站内容与数据均为演示用途，仅供浏览参考，不提供播放、下载与购买服务。
          </p>
        </div>
      </div>
    </footer>
  );
}